import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddTokensComponent } from '../../wallet/add-tokens/add-tokens.component';

@Component({
  selector: 'app-token-declined',
  templateUrl: './token-declined.component.html',
  styleUrls: ['./token-declined.component.scss']
})
export class TokenDeclinedComponent implements OnInit {

  @Input() public message;
  @Input() public closeOnSave;
  @Input() public promoCode;
  @Input() public sourcePlan;
  @Input() public inputTokens;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal, ) { }

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }

  addTokens() {
    if (this.closeOnSave) {
      this.activeModal.close(true);
      return
    }
    this.closeDialog();
    const modalRef = this.modalService.open(AddTokensComponent, { size: 'lg', centered: true, windowClass: 'add-token' });
    modalRef.componentInstance.sourcePlan = this.sourcePlan;
    if(this.sourcePlan === 'addons'){
      modalRef.componentInstance.inputTokens = this.inputTokens;
    }

  }

  applyPromoCode() {
    // if (this.closeOnSave) {
    //   this.activeModal.close(true);
    //   return
    // }
    // this.closeDialog('promo');
    this.activeModal.close('promocode');

  }

}
